import { render, staticRenderFns } from "./TypingSuggestions.vue?vue&type=template&id=3772bb6a&scoped=true&"
import script from "./TypingSuggestions.vue?vue&type=script&lang=js&"
export * from "./TypingSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./TypingSuggestions.vue?vue&type=style&index=0&id=3772bb6a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3772bb6a",
  null
  
)

export default component.exports